export const EmailsAddress = {
  SupportEmail: "support@freewave.com",
};
